






import { LocalizationMixin } from '@/main/mixins/localization';
import { InterniDruh } from '@/modules/ciselnik/dilenske/internidruh';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm } from '@/main/pages';

import { types } from '../../store/types';
import { store } from '../../store/edit';

export default LocalizationMixin.extend({
	name: 'ZakazkaInterniDruhSelect',
	components: { InterniDruhSelect: InterniDruh.components.Select },
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_INTER_DRUH_SELECT_MAPPER}`,
			};
		},
		label(): string {
			return this.IsInterniNS
				? this.LocalizePopisostatni('INTR_DRUH_PRP')
				: this.LocalizePopisPoli('INTR_DRUH_PRP');
		},
		interniDruhFilter(): object {
			return { IntrDruhOzn: this.IntrDruhOzn };
		},
	},
	watch: {
		IntrDruhOzn(newValue) {
			if (newValue !== null) {
				this.interniDruhChange();
			}
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
	},
});
